import  request  from '../../Interceptor/request.js'

//缴费记录查询
export function paymentRecord(data) {
    return request({
        url: '/order/list',
        method: 'get',
        params:data
    })
}

//按照年查询
export function timeSel(data){
    return request({
        url:'/order/list/time',
        method: 'get',
        params:data
    })
}

